export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    let filter = '';
    if (state.selectedStatus && state.selectedStatus.value) {
      filter = `situacao in ('${state.selectedStatus.value.join('\',\'')}')`;
      if (state.selectedStatus.id === 'NAO_RESPONDIDA') {
        filter += ' and (situacaoCotacao = "ABERTA" or situacaoCotacao = "CARRINHO" or situacaoCotacao = "COMPRA")';
      }
    }
    if (state.searchText) {
      if (filter) {
        filter += ' and ';
      }
      filter += `(company like '%${state.searchText.toLowerCase()}%')`;
    }
    return filter;
  },
};
